import React, { useRef } from 'react';
import { Dialog, DialogContent, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  dialogPaper: {
    width: 992,
    maxWidth: 992,
  },
  dialogContentRoot: {
    padding: 0,

    '&:first-child': {
      paddingTop: 0,
    },
  },
  video: {
    width: '100%',
    display: 'block',
    objectFit: 'fill',
  },
});

export interface ChooseTypeGuideProps {
  onClose(): void;
}

export const ChooseTypeGuide: React.FC<ChooseTypeGuideProps> = ({ onClose }) => {
  const styles = useStyles();
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleClickDialog = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const handleClose = () => {
    onClose?.();
  };

  return (
    <Dialog
      open
      onClose={handleClose}
      onClick={handleClickDialog}
      classes={{ paper: styles.dialogPaper }}
    >
      <DialogContent classes={{ root: styles.dialogContentRoot }}>
        <video
          ref={videoRef}
          className={styles.video}
          src="https://landing-lens-support.s3.us-east-2.amazonaws.com/video/understand-the-different-project-types.mp4"
          poster="https://landing-lens-support.s3.us-east-2.amazonaws.com/video/understand-the-different-project-types-poster.png"
          controls
        />
      </DialogContent>
    </Dialog>
  );
};

export default ChooseTypeGuide;
